export const CAROUSEL_CHANGE_TIMEOUT = 30000;
// export const BANNER_CHANGE_TIMEOUT = 20000;
export const BANNER_CHANGE_TIMEOUT = 200000;
